import * as React from 'react';

import { AUTHENTICATION_MODAL_MODES } from 'bundles/authentication/constants';
import AuthenticationOption from 'bundles/user-account/components/AuthenticationOption';

class OndemandLoggedOutRedirector extends React.Component {
  render() {
    return <AuthenticationOption defaultMode={AUTHENTICATION_MODAL_MODES.LOGIN} />;
  }
}

export default OndemandLoggedOutRedirector;
